import react from "react";
import { Link } from "react-router-dom";
import { Button, Modal, Form, Spinner } from "react-bootstrap";
import { useState, useEffect } from "react";
import axios from "axios";
import Nav from "../../main/header";
import Footer from "../../main/footer";
import Whatsapp from "./whatsapp";
import Load from "./load"
import Card from 'react-bootstrap/Card';
import '../../styles/header.css';
import Error404 from "../../pages/Error404";


function Subcat() {
  const [allcats, setAllcats] = useState([]);
  const [load, setLoad] = useState([]);
  const [title, setTitle] = useState();
  const [hasFetched, setHasFetched] = useState(false);

  const [keyword, setkeyword] = useState();



  const [listcities, setCitiesList] = useState([]);

  const container = {
    hidden: { opacity: 1, scale: 0 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const getCities = async () => {
    const data = new FormData();
  
    try {
      const response = await axios({
        method: "post",
        url: "/pro/auth/allcity_search.php",
        data: data,
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      if (Array.isArray(response.data)) {
        setCitiesList(response.data);
      } else {
        console.warn("Expected array but got:", response.data);
        setCitiesList([]);
      }
    } catch (error) {
      console.error("Failed to fetch city list:", error.message);
      setCitiesList([]);
    }
  };
  


  useEffect(() => {
    getServercats()
    getCities()
  }, []);

  const items = [
    { name: 'Punjab' },
    { name: 'Khyber Pakhtunkhwa' },
    { name: 'Sindh' },
    { name: 'Balochistān' },
    { name: 'Gilgit-Baltistan' }
  ]

  const getServercats = async () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const id = params.get("id");
    const city = params.get("c");
    const product = params.get("product");
    const spplier = params.get("supplier");

    const cityy = params.get("city");
    const pro = params.get("pro");


    if (product != null && cityy == null && pro == null) {

      setkeyword(product)
      setTitle(product)

      const data = new FormData();
      data.append("key", product);
      data.append("val", "product");


      axios({
        method: "post",
        url: "/pro/manage_search.php",
        data: data,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((s) => {
          setAllcats(s.data);
          setHasFetched(true);
          console.log(s.data, "/pro/manage_search.php");
        })
        .catch((s) => {
          console.log("here catch =>>", s.message);
        });

    } else if (spplier != null) {
      setTitle(spplier)
      setkeyword(spplier)
      const data = new FormData();
      data.append("key", spplier);
      data.append("val", "company");


      axios({
        method: "post",
        url: "/pro/manage_search.php",
        data: data,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((s) => {
          setAllcats(s.data);
          setHasFetched(true);
          //  console.log(s.data,"/pro/manage_search.php");
        })
        .catch((s) => {
          //  console.log("here catch =>>", s);
        });

    } else if (product != null && cityy != null) {
      setTitle(product + " " + cityy)
      setkeyword(product)
      const data = new FormData();
      data.append("key", cityy);
      data.append("key1", product);
      data.append("val", "advance");


      axios({
        method: "post",
        url: "/pro/manage_search.php",
        data: data,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((s) => {
          setAllcats(s.data);
          setHasFetched(true);
          //  console.log(s.data,"/pro/manage_search.php");
        })
        .catch((s) => {
          //  console.log("here catch =>>", s);
        });


    } else if (product != null && pro != null) {
      setTitle(product + " " + pro)
      setkeyword(product)
      const data = new FormData();
      data.append("key", pro);
      data.append("key1", product);
      data.append("val", "pro_advance");


      axios({
        method: "post",
        url: "/pro/manage_search.php",
        data: data,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((s) => {
          setAllcats(s.data);
          setHasFetched(true);
          //  console.log(s.data,"/pro/manage_search.php");
        })
        .catch((s) => {
          //  console.log("here catch =>>", s);
        });

    }


  };



  const getServercatsUpdate = async (id) => {
    const data = new FormData();

    data.append("id", id);

    axios({
      method: "post",

      url: "/mainsite/suball.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        setAllcats(s.data);
        setHasFetched(true);
        // console.log(s.data);
      })
      .catch((s) => {
        // console.log("here catch", s);
      });
  };

  return (
    <div style={{ backgroundColor: "#F4F5F8" }}>
      <Nav />

      <div style={{ marginTop: "20px" }} className="container">
        <div className="row">
        <div className="col-lg-12">
    <div className="container mt-1 main-heading-style">
      <h3 className="fw-bold text-center">Search Details</h3>
    </div>
  </div>
          <div className="col-12 col-md-9">
          <section className="padding-bottom-sm">
  {hasFetched && allcats.length === 0 ? <Error404 message="Not found" /> : allcats.length === 0 && <Error404 message={"Plase Wait,.."}  /> }

  {allcats.length > 0 && (
    <div className="row">
      {allcats.map((v, i) => (
   <div key={i} className="col-6 col-md-4 col-lg-3 mb-4">
   <a
     href={"product?id=" + v.pid + "&s=" + v.title}
     className="text-decoration-none"
   >
     <div
       className="custom-card d-flex flex-column justify-content-between text-center h-100 p-3"
       style={{
         borderRadius: "12px",
         boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
         transition: "transform 0.3s",
       }}
       onMouseEnter={(e) =>
         (e.currentTarget.style.transform = "scale(1.03)")
       }
       onMouseLeave={(e) =>
         (e.currentTarget.style.transform = "scale(1)")
       }
     >
       {/* Image */}
       <div
         className="card-img-wrapper mb-3"
         style={{
           width: "100%",
           height: "200px",
           overflow: "hidden",
           display: "flex",
           justifyContent: "center",
           alignItems: "center",
         }}
       >
         <img
           src={v.img}
           alt={v.title}
           className="card-img-top"
           loading="lazy"
           decoding="async"
           style={{
             width: "100%",
             height: "100%",
             objectFit: "contain", // 🔥 this makes sure the image fits perfectly
             borderRadius: "20px",
           }}
         />
       </div>

       <div>
         <h6 className="mb-1 text-dark fw-semibold">{v.title}</h6>
       </div>
 
       {/* Button at bottom */}
       <div className="mt-auto">
               {/* Title & Price */}
       <div>
         <p
           className="my-2"
           style={{
             fontSize: "16px",
             fontWeight: 700,
             color: v.price != 0 ? "#036770" : "red",
           }}
         >
          {
           v.price != 0 ? new Intl.NumberFormat("en-PK", {
             style: "currency",
             currency: "PKR",
             minimumFractionDigits: 2,
           }).format(v.price) : window.zero_price }
         </p>
       </div>
         <button
           className="btn btn-sm w-100"
           style={{
             maxHeight: "50px",
             borderRadius: "5px",
             backgroundColor: "#45ACB3",
             color: "white",
             border: "none",
             boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
             fontSize: "13px",
           }}
         >
           Get Quote
         </button>
       </div>
     </div>
   </a>
 </div>
 
      ))}
    </div>
  )}
</section>


          </div>
          {/* <div className="col-8" > */}
          {/* <div className="container"> */}
          <div className="col-12 col-md-3" style={{marginTop:'6px'}}>
          <section className="padding-bottom-sm">
            <div className="row">
              <div className="col-12 mb-4">
              <div
              className="custom-card d-flex flex-column justify-content-between text-left h-100 p-3"
              style={{
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                transition: "transform 0.3s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.03)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
                <h4 className="main-heading-style">Provinces</h4>

                      {
                        items.map((v, i) => (
                          <div className="province-items" >
                            {
                              i < 400 ? 
                              <span style={
                                {
                                  fontSize: '14px',
                                  lineHeight: '32px',
                                  color: '#020617',
                                  display: 'inline-block',
                                  marginLeft: '10px'
                                }
                              }>

                              <a 
                               style={
                                {
                                  fontSize: '14px',
                                  lineHeight: '32px',
                                  color: '#020617',
                                  display: 'inline-block'
                                }
                              }
                              href={"search?product=" + keyword + "&pro=" + v.name}>{v.name}

                              </a></span> : ""
                              
                            }

                          </div>

                        ))
                      }
                  
                </div>
              </div>
              <div className="col-12 mb-4">
              <div
              className="custom-card d-flex flex-column justify-content-between text-left h-100 p-3"
              style={{
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                transition: "transform 0.3s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.03)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
                  <h4 className="main-heading-style">City</h4>
                    <div style={{ height: "500px", overflowY: "auto", overflowX: "hidden", width: "100%" }}>
                      <div className="row">
                        {
                          listcities.map((v, i) => (
                            <div className="city-items" >
                              {
                                i < 50 ? 
                                <span style={
                                  {
                                    fontSize: '14px',
                                    lineHeight: '32px',
                                    color: '#020617',
                                    display: 'inline-block',
                                    marginLeft: '10px'
                                  }
                                }>
  
                                <a 
                                 style={
                                  {
                                    fontSize: '14px',
                                    lineHeight: '32px',
                                    color: '#020617',
                                    display: 'inline-block'
                                  }
                                }
                                
                                 href={"search?product=" + keyword + "&city=" + v.name}>  {v.name}</a> 
                                  </span>
                              : ''
                              }
                                

                            </div>

                          ))
                        }
                      </div>

                    </div>
                </div>

                <br />
              </div>





            </div>
            </section>
            {/* </div> */}

            {/* </div> */}

          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Subcat;
<a
  rel="nofollow"

  ads-data="t:117,clc:4,clt:1,hrty:1,aid:NGTfRQJMWaIt,st:8,a:1"
  target="_blank"
  href="https://activity.made-in-china.com/show/PQJaCmUDzEcx/AQETbJuxenkm"
  className="banner-wrap swiper-slide J-probe-banner-item"
  title="Live Show"
  alt="Live Show"
  pic1024="https://image.made-in-china.com/152f0j10NGRfuQaMoYVU/banner1024X300.jpg"
  pic1440="https://image.made-in-china.com/151f0j10NGRfuQaMoYVU/banner990X400.jpg"
  cz-position="top"
  cz-num="1"
  sensors-data="bId:1111021804,bName:Live Show"
  style='background-image: url("https://image.made-in-china.com/151f0j10NGRfuQaMoYVU/banner990X400.jpg"); width: 848px; height: 400px;'
  faw-id="1fubrqvtra81"
></a>;
